module.exports = __webpack_public_path__ + "static/media/event-services-img37.4bf46318.jpg";